import React from "react";
import RejectLicense from "@features/licensing/license-details/flow/rejectLicense/RejectLicense.tsx";
import type { VendorLicenseTask, VendorLicenseTaskDecision } from "@services/licensing/types";
import ApproveLicense from "./approveLicense/ApproveLicense";
import ClaimLicense from "./ClaimLicense";
import DownloadCsv from "./DownloadCsv";
import PrintLicense from "./PrintLicense";
import RenewPortOperatorLicense from "./renew-license/RenewPortOperatorLicense";
import RequestVendorLicenseRenewal from "./renew-license/RequestVendorLicenseRenewal";
import UnclaimLicense from "./UnclaimLicense";

type LicenseFlowData = {
  id: string;
  companyId?: string | null;
  status: string;
  task: VendorLicenseTask | null;
  taskDecision?: VendorLicenseTaskDecision | null;
};

interface LicenseFlowButtonsProps {
  refetchLicense: () => Promise<unknown> | void;
  licenseFlowData?: LicenseFlowData;
  isPortOperatorContext?: boolean;
  isPortOperatorLicense?: boolean;
  isVendorMasterContext?: boolean;
  openDrawer: (drawerName: string) => void;
  onPrint?: () => void;
}

const LicenseFlowButtons: React.FC<LicenseFlowButtonsProps> = ({
  refetchLicense,
  licenseFlowData,
  isPortOperatorContext = false,
  isPortOperatorLicense = false,
  isVendorMasterContext = false,
  openDrawer,
  onPrint,
}) => {
  return (
    <div className="flex gap-4">
      {licenseFlowData && (
        <>
          <RequestVendorLicenseRenewal
            licenseId={licenseFlowData.id}
            companyId={
              licenseFlowData.taskDecision?.companyId ?? licenseFlowData?.companyId ?? null
            }
            status={licenseFlowData.status}
            isPortOperatorLicense={isPortOperatorLicense}
            isVendorMasterContext={isVendorMasterContext}
          />
          <RenewPortOperatorLicense
            licenseId={licenseFlowData.id}
            companyId={licenseFlowData.companyId ?? null}
            status={licenseFlowData.status}
            isPortOperatorLicense={isPortOperatorLicense}
            isVendorMasterContext={isVendorMasterContext}
          />
        </>
      )}
      {!isPortOperatorLicense && <DownloadCsv licenseFlowData={licenseFlowData} />}

      <PrintLicense licenseFlowData={licenseFlowData} onPrint={onPrint} />
      <ClaimLicense
        refetchLicense={refetchLicense}
        licenseFlowData={licenseFlowData}
        isPortOperatorContext={isPortOperatorContext}
      />
      <UnclaimLicense
        refetchLicense={refetchLicense}
        licenseFlowData={licenseFlowData}
        isPortOperatorContext={isPortOperatorContext}
      />
      <RejectLicense licenseFlowData={licenseFlowData} openDrawer={openDrawer} />
      <ApproveLicense licenseFlowData={licenseFlowData} openDrawer={openDrawer} />
    </div>
  );
};

export default LicenseFlowButtons;
